



















import { defineComponent, ref } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { getCurrencyCode, getCurrencySymbol } from "@/lib/moneyHelpers";
import { INPUT_PROPS } from "@/const";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "InputMoney",
  components: { BaseInput },
  props: {
    ...INPUT_PROPS,
  },
  setup(props, { emit }) {
    const currencySymbol = $t(getCurrencySymbol(getCurrencyCode()));
    const inputValue = ref("");

    const regexInput = currencySymbol
      .split("")
      .map(i => {
        if (["[", "]", "\\", "^", "$", ".", "|", "?", "*", "+", "(", ")"].includes(i)) {
          return `\\${i}`;
        }
        return i;
      })
      .join("")
      .concat("(\\d*)");

    const onInput = (v: string) => {
      const value = Number(v.replace(currencySymbol, "") ?? 0) || 0;
      if (isNaN(value) || value === 0) {
        inputValue.value = "";
      } else {
        inputValue.value = value.toString();
      }
      emit("input", inputValue.value);
    };

    return { currencySymbol, inputValue, onInput, regexInput };
  },
});
